import apiClient from './Api';
const PREFIX = '/eventlogs';

const eventLogContactSupport = postData => {
  return apiClient({
    url: `${PREFIX}/contact-support`,
    method: 'POST',
    data: postData
  });
};

const EventLogContactSupportService = {
  eventLogContactSupport
};

export default EventLogContactSupportService;
